import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const PrivacyPolicy = () => {

  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <div className="container mx-auto px-4 py-16 text-white/90 pt-24 md:pt-20">
        <div className="max-w-4xl mx-auto space-y-8">
          <h1 className="text-3xl font-bold mb-8 text-[#9E7C47]">Privacy Policy</h1>
         
          <section>
            <h2 className="text-xl font-semibold mb-4">1. Introduction</h2>
            <p className="text-white/70">
              This Privacy Policy outlines how WealthManager.online ("Platform") collects, uses, stores, and discloses your information. By accessing the Platform, you agree to the practices described here. This Policy complies with the Digital Personal Data Protection Act, 2023 (India).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">2. Information We Collect</h2>
            <p className="text-white/70">
              <strong>a. Personal Information (with user consent)</strong><br />
              - Full Name, Email Address, Phone Number<br />
              - Age and Gender (if voluntarily provided)<br />
              - Investment preferences and financial goals<br />
              - PAN or KYC details (only if explicitly enabled)<br />
              <br />
              <strong>b. Usage Data</strong><br />
              - IP address, device, and browser information<br />
              - Time spent, pages visited, and clickstream data<br />
              - Interactions with AI assistant<br />
              <br />
              <strong>c. Third-party Data (optional and with consent)</strong><br />
              - Data from linked broker or bank accounts<br />
              - Public financial records and related metadata
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">3. How We Use Your Information</h2>
            <ul className="list-disc pl-6 text-white/70 space-y-1">
              <li>To personalize news and insights</li>
              <li>To enhance the accuracy of AI-based recommendations</li>
              <li>To maintain platform security and prevent misuse</li>
              <li>To send alerts, updates, or promotional content (you can opt out)</li>
              <li>To comply with legal obligations (if applicable)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">4. Data Sharing & Disclosure</h2>
            <ul className="list-disc pl-6 text-white/70 space-y-1">
              {/* <li>We do <strong>not</strong> sell your personal data.</li> */}
              <li>Data may be shared with service providers (e.g., cloud hosting, analytics).</li>
              <li>Data may be disclosed to legal/government bodies when required.</li>
              <li>Broker or third-party integrations occur only with explicit user consent.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">5. Your Rights</h2>
            <p className="text-white/70">
              Under the DPDP Act, you have the right to:
            </p>
            <ul className="list-disc pl-6 text-white/70 space-y-1">
              <li>Access, correct, or delete your personal data</li>
              <li>Withdraw consent at any time</li>
              <li>Request a copy of your data</li>
            </ul>
            <p className="text-white/70 mt-4">
              To exercise these rights, contact us at support@wealthmanager.online.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">6. Data Security</h2>
            <p className="text-white/70">
              We use industry-standard security measures such as encryption, secure server access, and restricted data control to protect your data.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">7. Retention of Data</h2>
            <p className="text-white/70">
              We retain user data only as long as necessary for the stated purposes or as required by law.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">8. Changes to Privacy Policy</h2>
            <p className="text-white/70">
              This Privacy Policy may be updated from time to time. You are advised to review this page periodically.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">9. Contact Us</h2>
            <p className="text-white/70">
              If you have questions or concerns:
            </p>
            <p className="text-white/70 mt-4">
              WealthManager AI<br />
              Email: support@wealthmanager.online<br />
              Website: https://www.wealthmanager.online
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;